<template>
	<div id="app">
		<Header/>
	    <router-view/>
	    <Footer/>
	</div>
</template>

<script>
import 'babel-polyfill'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
    name: 'App',
    components:{
		Header,
		Footer
    },
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return {
        isRouterAlive:true,
      }
    },
    data(){
	  	return {
	  	}
	},
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        });
      },
    }
}
</script>

<style>
body{
	padding: 0;
	margin: 0;
}

#app {
  font-family:  微软雅黑,'Heiti SC',黑体,Arial;
  text-align: center;
  color: #2c3e50;
}
.swiper-container {
    width: 100%;
    height: 100%;
}
.swiper-slide {
    height: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
::-webkit-scrollbar{
	width:0;
}
.ql-align-center{
	text-align: center;
}
.ql-align-right{
	text-align: right;
}
.ql-align-justify{
	text-indent: 2em;
	float: left;
}
.el-carousel__container{
	height: 100% !important;
}
.el-carousel__button{
	height: 5px;
}
.el-carousel__arrow{
	width: 60px;
	height: 60px;
	font-size: 24px;
}
p{
	margin: 0;
	padding: 0;
}
img{
	width: 65%;
}
#_ideConac img{
  width: 100%;
}
.foinner>i{
	font-style: normal;
    width: 20px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #404040;
    margin: 0 3px;
    display: inline-block;
}
@-webkit-keyframes yAxis {
      50% {
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
        -webkit-transform: translateY(700px);
        transform: translateY(700px);
      }
    }
    @keyframes yAxis {
      50% {
        -webkit-animation-timing-function: ease-out;
        animation-timing-function:ease-out;
        -webkit-transform: translateY(700px);
        transform: translateY(700px);
      }
    }
    @-webkit-keyframes xAxis {
      50% {
        -webkit-animation-timing-function:ease-in;
        animation-timing-function: ease-in;
        -webkit-transform: translateX(1200px);
        transform: translateX(1200px);
      }

    }
    @keyframes xAxis {

      50% {
        -webkit-animation-timing-function:ease-in;
        animation-timing-function: ease-in;
        -webkit-transform: translateX(1200px);
        transform: translateX(1200px);
      }
    }
    .el-tabs__item{
	    line-height: 30px !important;
		font-size: 1.3em !important;
		font-weight: bold !important;
		color: rgb(176, 153, 138) !important;
    }
    .el-tabs__item:hover{
    	color: rgba(176, 153, 138, 0.5) !important;
    }
    .el-tabs__item.is-active {
	    color: rgba(176, 153, 138, 0.8) !important;
	}
	.el-tabs__active-bar{
	    background-color:rgba(176, 153, 138, 0.8) !important;
	}

  .xgplayer-skin-default video {
      width: 100%;
      height: 100%;
      outline: none;
  }
  <style>
  .xgplayer-skin-default * {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue